import React from "react";
import { Bar, Line } from "react-chartjs-2";
import Plot from "react-plotly.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend, Title);

const baseOptions = (title) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: !!title, text: title },
  },
});

/** Renders the `chart` envelope field returned by analysis_engine (bar/line/scatter). */
function ChartRenderer({ chart }) {
  if (!chart) return null;

  if (chart.type === "bar") {
    return (
      <div className="analysis-chart">
        <Bar
          data={{
            labels: chart.x,
            datasets: [{ data: chart.y, backgroundColor: "rgba(59, 130, 246, 0.7)" }],
          }}
          options={baseOptions(chart.title)}
        />
      </div>
    );
  }

  if (chart.type === "line") {
    return (
      <div className="analysis-chart">
        <Line
          data={{
            labels: chart.x,
            datasets: [{ data: chart.y, borderColor: "rgba(59,130,246,0.9)", backgroundColor: "rgba(59,130,246,0.2)", fill: true, tension: 0.25 }],
          }}
          options={baseOptions(chart.title)}
        />
      </div>
    );
  }

  if (chart.type === "scatter") {
    const hasColor = Array.isArray(chart.color);
    return (
      <div className="analysis-chart">
        <Plot
          data={[{
            x: chart.x,
            y: chart.y,
            mode: "markers",
            type: "scattergl",
            marker: hasColor
              ? { color: chart.color, colorscale: "Viridis", size: 6, showscale: true }
              : { size: 6, color: "rgba(59,130,246,0.7)" },
          }]}
          layout={{ title: chart.title, autosize: true, margin: { t: 40 } }}
          style={{ width: "100%", height: "360px" }}
          useResizeHandler
        />
      </div>
    );
  }

  return null;
}

export default ChartRenderer;
